define(['text!./templates/ho-edit-coverages.html'],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    model: '=gwQnbHoEditCoverages',
                    onCovChange: '=',
                    onGeneralChange: '=',
                    loading: '=?',
                    lob: '@'
                }
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/directives/HOEditCoverages.js
 **/